/**
 * Opens the product-card BIS modal and sets the current variant SKU from the card's variant picker.
 */
(function () {
  function openBISModal(trigger) {
    const form = trigger.closest('form');
    if (!form || !form.attributes.id || !form.attributes.id.value.startsWith('product-form-')) return
    const sectionId = form.attributes.id.value.replace('product-form-', '')
    const picker = document.querySelector(`hh-variant-picker[data-section="${sectionId}"]`)
    if (!picker || !picker.currentVariant) return
    const skuInput = document.getElementById('bis-sku-modal')
    if (skuInput) skuInput.value = picker.currentVariant.sku || ''
    document.body.setAttribute('modal', JSON.stringify({ id: 'product-card-bis-modal' }))
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-bis-modal-trigger]')
    if (trigger) {
      e.preventDefault()
      openBISModal(trigger)
    }
  })
})()
